import { Villa } from '../types';
import VillaCard from './VillaCard';

interface VillasViewProps {
  villas: Villa[];
  viewMode: 'grid' | 'list';
  onSelect: (villa: Villa) => void;
  onUpdate: (villa: Villa) => void;
  onMoveToArchive: (id: string) => void;
}

export default function VillasView({
  villas,
  viewMode,
  onSelect,
  onUpdate,
  onMoveToArchive,
}: VillasViewProps) {
  return (
    <main className="p-4 space-y-4">
      {villas.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-20 text-center">
          <p className="text-muted-foreground">Нет вилл</p>
          <p className="text-sm text-muted-foreground mt-1">
            Добавьте ссылки на виллы в Telegram-чат
          </p>
        </div>
      ) : (
        <div className={viewMode === 'grid' ? 'grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3' : 'flex flex-col gap-3'}>
          {villas.map((villa) => (
            <VillaCard
              key={villa.id}
              villa={villa}
              viewMode={viewMode}
              onSelect={onSelect}
              onUpdate={onUpdate}
              onMoveToArchive={onMoveToArchive}
            />
          ))}
        </div>
      )}
    </main>
  );
}
